"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        flex-basis: ", ";\n        max-width: ", ";\n      }\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n        @media (min-width: ", "px) {\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n        }\n      "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        flex-basis: ", ";\n        max-width: ", ";\n      }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n        @media (min-width: ", "px) {\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n        }\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        flex-basis: ", ";\n        max-width: ", ";\n      }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        @media (min-width: ", "px) {\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n        }\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "px) {\n        flex-basis: ", ";\n        max-width: ", ";\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        @media (min-width: ", "px) {\n          flex-grow: 1;\n          flex-basis: 0;\n          max-width: 100%;\n        }\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      flex-basis: ", ";\n      max-width: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        flex-grow: 1;\n        flex-basis: 0;\n        max-width: 100%;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin: ", "px;\n    width: calc(100% + ", "px);\n    & > .__grid_item__ {\n      padding: ", "px;\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    min-width: 0;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    margin: 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  ", "\n  \n  align-content: ", ";\n  align-items: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var COLUMNS = 12;
var BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};

var StyledGrid = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.container && (0, _styledComponents.css)(_templateObject2());
}, function (props) {
  return props.item && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.zeroMinWidth && (0, _styledComponents.css)(_templateObject4());
}, function (props) {
  return props.container && props.spacing && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return -props.spacing / 2;
  }, props.spacing, props.spacing / 2);
}, function (props) {
  if (!props.item || !props.xs) {
    return;
  }

  if (props.xs === true) {
    return (0, _styledComponents.css)(_templateObject6());
  } // Keep 7 significant numbers.


  var width = "".concat(Math.round(props.xs / COLUMNS * 10e7) / 10e5, "%");
  return (0, _styledComponents.css)(_templateObject7(), width, width);
}, function (props) {
  if (!props.item || !props.sm) {
    return;
  }

  if (props.sm === true) {
    return (0, _styledComponents.css)(_templateObject8(), props.breakpoints.sm);
  } // Keep 7 significant numbers.


  var width = "".concat(Math.round(props.sm / COLUMNS * 10e7) / 10e5, "%");
  return (0, _styledComponents.css)(_templateObject9(), props.breakpoints.sm, width, width);
}, function (props) {
  if (!props.item || !props.md) {
    return;
  }

  if (props.md === true) {
    return (0, _styledComponents.css)(_templateObject10(), props.breakpoints.md);
  } // Keep 7 significant numbers.


  var width = "".concat(Math.round(props.md / COLUMNS * 10e7) / 10e5, "%");
  return (0, _styledComponents.css)(_templateObject11(), props.breakpoints.md, width, width);
}, function (props) {
  if (!props.item || !props.lg) {
    return;
  }

  if (props.lg === true) {
    return (0, _styledComponents.css)(_templateObject12(), props.breakpoints.lg);
  } // Keep 7 significant numbers.


  var width = "".concat(Math.round(props.lg / COLUMNS * 10e7) / 10e5, "%");
  return (0, _styledComponents.css)(_templateObject13(), props.breakpoints.lg, width, width);
}, function (props) {
  if (!props.item || !props.xl) {
    return;
  }

  if (props.xl === true) {
    return (0, _styledComponents.css)(_templateObject14(), props.breakpoints.xl);
  } // Keep 7 significant numbers.


  var width = "".concat(Math.round(props.xl / COLUMNS * 10e7) / 10e5, "%");
  return (0, _styledComponents.css)(_templateObject15(), props.breakpoints.xl, width, width);
}, function (props) {
  return props.alignContent !== Grid.defaultProps.alignContent && props.alignContent;
}, function (props) {
  return props.alignItems !== Grid.defaultProps.alignItems && props.alignItems;
}, function (props) {
  return props.flexDirection !== Grid.defaultProps.flexDirection && props.flexDirection;
}, function (props) {
  return props.flexWrap !== Grid.defaultProps.flexWrap && props.flexWrap;
}, function (props) {
  return props.justifyContent !== Grid.defaultProps.justifyContent && props.justifyContent;
});

var Grid = function Grid(props) {
  return _react["default"].createElement(StyledGrid, _extends({
    className: (0, _classnames["default"])({
      '__grid_item__': props.item
    })
  }, props));
};

Grid.displayName = 'Grid';
Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes["default"].oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes["default"].oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * Defines the pixel values for each breakpoint
   */
  breakpoints: _propTypes["default"].shape({
    xs: _propTypes["default"].number.isRequired,
    sm: _propTypes["default"].number.isRequired,
    md: _propTypes["default"].number.isRequired,
    lg: _propTypes["default"].number.isRequired,
    xl: _propTypes["default"].number.isRequired
  }),

  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,

  /**
   * @ignore
   */
  className: _propTypes["default"].string,

  /**
   * Defines the number of grid columns
   */
  columns: _propTypes["default"].number,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes["default"].bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  flexDirection: _propTypes["default"].oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  flexWrap: _propTypes["default"].oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes["default"].bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justifyContent: _propTypes["default"].oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grid columns the component is going to span.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes["default"].oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grid columns the component is going to span.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes["default"].oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grid columns the component is going to span.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes["default"].oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grid columns the component is going to span.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes["default"].number,

  /**
   * Defines the number of grid columns the component is going to span.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes["default"].oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grid columns the component is going to span.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes["default"].oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes["default"].bool
};
Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  breakpoints: BREAKPOINTS,
  columns: 12,
  container: false,
  flexDirection: 'row',
  flexWrap: 'wrap',
  item: false,
  justifyContent: 'flex-start',
  lg: false,
  md: false,
  sm: false,
  spacing: 0,
  xl: false,
  xs: false,
  zeroMinWidth: false
};
var _default = Grid;
exports["default"] = _default;